import { BeforeInstallPromptEvent } from '@src/types/beforeInstallPrompt.types'
import { computed, ref } from 'vue'
import { useEventListener } from '@vueuse/core'
import { defineStore } from 'pinia'
import { useFeatureToggles } from '@src/composables/featureToggles'

export const useBeforeInstallPromptStore = defineStore('beforeInstallPrompt', () => {
  const { installPwaEnabled } = useFeatureToggles()
  const deferredPrompt = ref<BeforeInstallPromptEvent | undefined>(undefined)
  const isPWAInstallableAutomatically = computed(() => !!deferredPrompt.value && installPwaEnabled.value)

  // It can also happen that the beforeinstallprompt fires while navigating the application (especially for first or second time users)
  // That's why we're also listening to the event in every component that's using it in addition to the very beginning in main.ts
  useEventListener(window, 'beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt.value = e as BeforeInstallPromptEvent
  })

  return {
    deferredPrompt,
    isPWAInstallableAutomatically
  }
})
